

const axios = require('axios');
const commsErrors =  require('./communicationErrors');

module.exports = (authApiRootUrl, bundleName, jwt) => {
    const url = `${authApiRootUrl}/v2/bundles/${bundleName}/metadata`;
    return axios.get(url, {
        headers: {
            authorization: `Bearer ${jwt}`
        }
    })
        .then(res => res.data)
        .catch(() => Promise.reject(commsErrors.createRequestError()));
};
